import CreateXeroInvoices from "./CreateXeroInvoices";
import XeroFeatureFlagCheck from "../../../../../utils/XeroFeatureFlagCheck";

function CreateXeroInvoicesWrapper() {
    return (
        <XeroFeatureFlagCheck>
            <CreateXeroInvoices />
        </XeroFeatureFlagCheck>
    )
}

export default CreateXeroInvoicesWrapper;